
import React from 'react';
import {useMainHook} from './Hooks';
import MainComponent from './Component';

const Main = () => {
  return <MainComponent {...useMainHook()} />
}
export default Main;           
                